define('views/shared/alerts/action_alert',["views/_base/baseview", "text!views/shared/alerts/action_alert.html"], function (BaseView, Template) {
	"use strict";

	return BaseView.extend({
		className: "action-alert-container",
		tagName: "div",
		isRender: true,
		template: _.template(Template),
		events: {
			"click #pf-modal-close-btn": "closeMODAL",
			"click .js-button-success-modal-btn": "successConfirmationMODAL",
		},
		initialize: function (options) {
			options = options || {};

			this.data = options.data;
			this.calling_view_MODAL = options.calling_view_MODAL;

			this.options = options.opt;

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this;

			// Because the parent view is in a Modal, access the element name through the parent view
			this.data.$el.find(this.elementName).html(this.template());

			setTimeout(function () {
				that.addContent();
			}, 300);

			return this;
		},

		loadData: function () {},

		addContent: function () {
			if (_.isObject(this.options)) {
				if (this.options.icon) {
					var content_container = this.data.$el.find(this.elementName).find(".js-action-alert-content"),
						content_inner_container = document.createElement("div"),
						header = document.createElement("h2"),
						icon_container = document.createElement("div"),
						content = document.createElement("div");

					header.innerHTML = this.data.alert_content_header;

					icon_container.className = "action-alert-icon-container";
					icon_container.innerHTML = pf.getContent(this.data.alert_message_icon)
						? pf.getContent(this.data.alert_message_icon)
						: this.data.alert_message_icon;

					content.className = "action-alert-message-container";
					content.innerHTML = this.data.alert_message;

					content_inner_container.className = "action-alert-content-icon";

					content_inner_container.appendChild(header);

					content_inner_container.appendChild(icon_container);

					content_inner_container.appendChild(content);

					$(".js-action-alert-content").html(content_inner_container);
				}
			} else {
				$(".js-action-alert-content").html(
					'<p class="action-alert-message js-alert-action-message">' + this.data.alert_message + "</p>"
				);
			}
		},

		successConfirmationMODAL: function () {
			this.closeMODAL();
		},

		updateDataMODAL: function (data) {
			this.data = data;
			this.render();
		},

		closeMODAL: function () {
			// console.log('action_alert closeMODAL');
			this.calling_view_MODAL.successModalCallbackMODAL();

			$("#pf-modal-modern").fadeOut(function () {
				$("#pf-modal-modern").remove();
			});
		},

		close: function () {},
	});
});

